import type { FunctionComponent, PropsWithChildren } from 'react';
import ButtonAction from '../../interfaces/buttonAction';
import NavigationFooter from '../navigation-footer';
import * as styles from './NavigationWrapper.module.css';

interface LayoutProps {
  backButton: ButtonAction;
  nextButton: ButtonAction;
  isQuestionPage?: boolean;
}

const NavigationWrapper: FunctionComponent<PropsWithChildren<LayoutProps>> = ({
  children,
  backButton,
  nextButton,
  isQuestionPage,
}) => (
  <div className={styles.layoutContainer} data-testid="navigation-wrapper">
    {children}
    <NavigationFooter
      backButton={backButton}
      nextButton={nextButton}
      isQuestionPage={isQuestionPage}
    />
  </div>
);

export default NavigationWrapper;
